import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { UserStore } from 'src/Stores/User/UserStore';
import { IContractor } from '../../../../Interfaces/AdminInterface';
import DataService from '../../../../Services/Data';
import DataTable from '../../../DataTable';

interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class AdminContractors extends React.Component {
    public props: any;
    public adminStore: any;
    public contractorsDisposer: any; 
    public contractors: IContractor[] = [];
    public contractorList: IList;
    public dataService: any = new DataService();
    private UserStore: UserStore;

    private tableHeaders: any[] = [
        { content: 'Name', 'class': 'align-left' },
        { content: 'Group Email', 'class': 'align-left' },
    ];


    public state = {
        contractors: this.contractors,
        formattedContractorData: this.contractorList,
    };

    constructor(props: any) {
        super(props);
        this.UserStore = this.props.stores.UserStore;
    }

    public componentDidMount() {
        this.adminStore = this.props.stores.AdminStore;

        this.createDisposers();

        this.adminStore.getContractors();
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.contractorsDisposer = intercept(this.adminStore, 'contractors', (change: any) => {
            let data = change.newValue;

            data = this.dataService.sort(data, { name: 'asc' });

            this.setState({
                contractors: data
            });

            this.formatDataTable();

            return change;
        });
    }

    public clearDisposers() {
        this.contractorsDisposer();
    }

    public renderContractorName(contractor: IContractor) {
        return(
            <Link to={'/admin/contractors/' + contractor.id}>{contractor.contractorName}</Link>
        );
    }

    public formatDataTable() {
        const formattedData: any[] = [];
        this.state.contractors.map((contractor: IContractor, index: number) => {
            const row = [
                {
                    'class': 'align-left',
                    content: this.renderContractorName.bind(this, contractor),
                    sortItem: contractor.contractorName,
                    type: 'render'
                },
                {
                    'class': 'align-left',
                    content: contractor.groupEmails.map(ge => ge.email).join(', ')
                }
            ];
            formattedData.push(row);
        });

        this.setState({
            formattedContractorData: {
                headers: this.tableHeaders,
                rows: formattedData
            }
        });
    }

    public render() {
        return(
            <div>
                <Row className="header">
                    <Col md="6">
                        <h1 className="float-left">Contractors</h1>
                    </Col>
                    {
                        this.UserStore.hasPermission('Permissions.Admin.Contractors.Create') &&
                        <Col md="6">
                            <Link to="/admin/contractors/new">
                                <Button color="primary" className="float-right">
                                    Add New Contractor
                                </Button>
                            </Link>
                        </Col>
                    }
                </Row>
                <Row>
                    <Col xs="12">
                        <DataTable list={this.state.formattedContractorData} />
                    </Col>
                </Row>
            </div>
        );
    }

}

export default AdminContractors;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Contractors/AdminContractors.tsx